import axios from "axios";

import { reviewsRelatedAndAllSuccess } from "./reviews";
import { getAuthHeader } from "../headers";

// ===================================================================================
//  SEARCH REVIEWS (by sector)
// ===================================================================================
export const reviewSearchInProgress = () => {
	return {
		type: "REVIEW_SEARCH_IN_PROGRESS"
	};
};

export const reviewSearchHasError = err => {
	return {
		type: "REVIEW_SEARCH_HAS_ERROR",
		error: err
	};
};

export const reviewSearchSuccess = data => {
	return {
		type: "REVIEW_SEARCH_SUCCESS",
		data
	};
};

export function getReviewSearchBySector(term = null, sectorId = null, types = null) {
	return (dispatch, getState) => {
		dispatch(reviewSearchInProgress());

		const params = {};
		if (term !== null) {
			params.q = term;
		}

		if (sectorId !== null) {
			params.sector = sectorId;
		}

		if (types !== null) {
			params.types = types;
		}

		// Add id of record to find if passed
		const endPoint = "reviews/sectors";

		return axios
			.get(process.env.REACT_APP_API_URL + endPoint, {
				headers: getAuthHeader(getState().user),
				params
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					if (response.data.message !== "") {
						dispatch(reviewSearchHasError(response.data.message));
					} else {
						dispatch(reviewSearchHasError(response.data.errors));
					}
				} else {
					dispatch(reviewsRelatedAndAllSuccess(response.data.related, response.data.all));
					return dispatch(reviewSearchSuccess(response));
				}
			})
			.catch(err => {
				dispatch(reviewSearchHasError(err.response.data.message));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/reviewSearch.js